import { RequestError } from "@/shared/api/types";
import { AxiosError } from "axios";
import {
  insightsApiInstance,
  lodApiInstance,
  streamsApiInstance,
} from "./axios";
import { ExportAnnotationsRequest } from "./lod-api";

export const getAppKey = () => import.meta.env.VITE_APP_KEY;

export const getImageSrc = (imageId: string) => {
  const baseURL = insightsApiInstance.defaults.baseURL;
  return `${baseURL}/store_images/${imageId}`;
};

export const getCameraImageSrc = (cameraId: string) => {
  const baseURL = insightsApiInstance.defaults.baseURL;
  return `${baseURL}/camera_images/${cameraId}.jpg`;
};

export const getStoreKeyFromPath = () => {
  const pathParts = location.pathname.split("/").filter(Boolean);

  if (pathParts.length >= 2 && pathParts[0] === "stores") {
    return pathParts[1];
  }
};

export const getStoreKey = (storeKey?: string) => {
  return storeKey || getStoreKeyFromPath();
};

export const getFieldErrorMessage = (error: AxiosError<RequestError>) => {
  const errorData = error.response?.data;

  if (errorData && !!errorData.non_field_errors?.length) {
    return errorData.non_field_errors[0];
  }

  if (errorData && errorData.errors?.length > 0) {
    let loc = "";

    if (errorData?.errors[0]?.loc?.length > 0) {
      loc = `[${errorData?.errors[0]?.loc.join(".")}]: `;
    }

    return `${loc}${errorData?.errors[0]?.msg}`;
  }

  return error.response?.data.python_exc || error.message;
};

export const getVideoStreamUrl = ({
  cameraId,
  fromDateTime,
  toDateTime,
  isLive = false,
}: {
  cameraId: string;
  fromDateTime: Date;
  toDateTime?: Date;
  isLive?: boolean;
}) => {
  const url = new URL(
    `${streamsApiInstance.defaults.baseURL}/stream/v2/camera/${cameraId}/presign`
  );
  const search = url.searchParams;

  search.append("from_time", fromDateTime.toISOString());

  if (isLive) {
    search.append("align_segment", "false");
  }

  if (!isLive && toDateTime) {
    search.append("to_time", toDateTime.toISOString());
  }

  return url.href;
};

export const downloadAnnotationsExport = async (
  requestData: ExportAnnotationsRequest
): Promise<void> => {
  try {
    const response = await lodApiInstance.post(
      "/orders/export/annotations",
      requestData,
      {
        responseType: "blob",
      }
    );

    const contentDisposition = response.headers?.["content-disposition"];
    let filename = "annotations-export.zip";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename=["']?([^"';\n]*)["']?/i
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    } else {
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      filename = `annotations-export-${timestamp}.zip`;
    }

    const blob = response.data;

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);

    return;
  } catch (error) {
    console.error("Error downloading export:", error);
    throw error;
  }
};
